<div class="page-root">
  <div class="title">
    <div class="typo-h1 title-text">{{ 'waitlist.settings.title' | transloco }}</div>
    <button class="close" mat-dialog-close [aria-label]="'waitlist.action.close' | transloco">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="body">
    <div class="row">
      <mat-icon class="row-icon">notifications</mat-icon>

      <div class="row-text">
        <div class="row-title">{{ 'waitlist.settings.notifications.title' | transloco }}</div>
        <div class="body-text">{{ 'waitlist.settings.notifications.description' | transloco }}</div>
      </div>

      <mat-slide-toggle [checked]="notificationsEnabled" (change)="onToggle($event.checked)"/>
    </div>
  </div>
</div>
